import { storableError } from '../../util/errors';
import {
  fetchPostBySlug,
  fetchRelatedPosts,
} from '../BlogIndexPage/wpApi';

// ─── Action types ───────────────────────────────────────────────────────────
export const POST_REQUEST = 'app/BlogPostPage/POST_REQUEST';
export const POST_SUCCESS = 'app/BlogPostPage/POST_SUCCESS';
export const POST_NOT_FOUND = 'app/BlogPostPage/POST_NOT_FOUND';
export const POST_ERROR = 'app/BlogPostPage/POST_ERROR';
export const RELATED_SUCCESS = 'app/BlogPostPage/RELATED_SUCCESS';

// ─── Reducer ────────────────────────────────────────────────────────────────
const initialState = {
  post: null,
  related: [],
  notFound: false,
  loadInProgress: false,
  loadError: null,
};

const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case POST_REQUEST:
      return {
        ...state,
        loadInProgress: true,
        loadError: null,
        notFound: false,
        post: null,
        related: [],
      };
    case POST_SUCCESS:
      return { ...state, loadInProgress: false, post: payload };
    case POST_NOT_FOUND:
      return { ...state, loadInProgress: false, notFound: true, post: null };
    case POST_ERROR:
      return { ...state, loadInProgress: false, loadError: payload };
    case RELATED_SUCCESS:
      return { ...state, related: payload || [] };
    default:
      return state;
  }
};

export default reducer;

// ─── Action creators ────────────────────────────────────────────────────────
const postRequest = () => ({ type: POST_REQUEST });
const postSuccess = (post) => ({ type: POST_SUCCESS, payload: post });
const postNotFound = () => ({ type: POST_NOT_FOUND });
const postError = (e) => ({ type: POST_ERROR, error: true, payload: e });
const relatedSuccess = (related) => ({
  type: RELATED_SUCCESS,
  payload: related,
});

// ─── loadData (SSR entry point) ─────────────────────────────────────────────
export const loadData = (params) => (dispatch) => {
  const slug = params?.slug;
  if (!slug) {
    dispatch(postNotFound());
    return Promise.resolve();
  }

  dispatch(postRequest());

  return fetchPostBySlug(slug)
    .then((post) => {
      if (!post) {
        dispatch(postNotFound());
        return null;
      }
      dispatch(postSuccess(post));

      // Fire-and-forget related fetch — don't block render on this.
      const tagSlugs = (post.tags || []).map((t) => t.slug);
      return fetchRelatedPosts({
        excludeId: post.id,
        tagSlugs,
        limit: 4,
      })
        .then((related) => {
          dispatch(relatedSuccess(related));
          return post;
        })
        .catch(() => post);
    })
    .catch((e) => {
      const error = storableError(e);
      dispatch(postError(error));
    });
};
